import React from "react";

import {
  Button,
  Card,
  CardBody,
//   CardTitle,
  Content,
  Grid,
  GridItem,
//   Label,
  Stack,
  StackItem
} from "@patternfly/react-core";

import { SectionPanel } from "shared/components/SectionPanel";

const MapPanel = ({
  isCard = false,
  showHeader = true,
  showAction = true,
  title = "Mapa dojazdu",
  description = "Lokalizacja szkoły – sprawdź, jak do nas trafić.",
//   locationLabel = "Lokalizacja",
  locationTitle = "Zespół Szkół Zawodowych",
  locationDescription = null,
  mapSrc,
  actionLabel = "Wyznacz trasę",
  actionHref = null
}) => {
  const action =
    showAction && actionHref ? (
      <Button
        variant="primary"
        component="a"
        href={actionHref}
        target="_blank"
        rel="noopener noreferrer"
      >
        {actionLabel}
      </Button>
    ) : null;

  return (
    <SectionPanel
      isCard={isCard}
      action={action}
    >
      <Stack hasGutter>
        {showHeader && (title || description) && (
          <StackItem>
            <Grid>
              <GridItem
                span={10}
                offset={1}
                lg={8}
                lgOffset={2}
              >
                <Stack hasGutter>
                  {title && (
                    <StackItem>
                      <Content
                        component="h1"
                        style={{ textAlign: "center" }}
                      >
                        {title}
                      </Content>
                    </StackItem>
                  )}

                  {description && (
                    <StackItem>
                      <Content
                        component="p"
                        style={{ textAlign: "center" }}
                      >
                        {description}
                      </Content>
                    </StackItem>
                  )}
                </Stack>
              </GridItem>
            </Grid>
          </StackItem>
        )}

        <StackItem>
          <Card>
            {mapSrc && (
              <iframe
                src={mapSrc}
                title={`Mapa - ${locationTitle}`}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                style={{
                  display: "block",
                  width: "100%",
                  height: "300px",
                  border: 0
                }}
              />
            )}

            {/* <CardTitle>
              <Stack hasGutter>
                <StackItem isFilled />
                <StackItem>
                  <Label color="blue">
                    {locationLabel}
                  </Label>
                </StackItem>

                <StackItem>
                  <Content component="h2">
                    {locationTitle}
                  </Content>
                </StackItem>
              </Stack>
            </CardTitle> */}

            {locationDescription && (
              <CardBody>
                <Content component="p">
                  {locationDescription}
                </Content>
              </CardBody>
            )}
          </Card>
        </StackItem>
      </Stack>
    </SectionPanel>
  );
};

export default MapPanel;